<div class="drawer-wrap">
  <ng-content></ng-content>
</div>
